import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MfaChallengeModalComponent } from './components';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [MfaChallengeModalComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule, NgbModule],
  exports: [MfaChallengeModalComponent],
})
export class MfaModule {}
